module.exports = __webpack_public_path__ + "img/tema-3-20.45b7dc72.svg";